import React, { createContext, ReactElement, ReactNode } from 'react';
import { ContextFunctions, ContextState, ContextValue } from './perfil.sat.model';
import usePerfilSat from './use.perfil.sat';



const initialValues: ContextValue = {
  inputLogin: '',
  inputType: '',
  showOtp: false,
  errorMessages: '',
  userToken: '',
  otp: '',
  userProfile: {},
  maskedPhone: '',
  errorMessagesOtp: '',
  selectedFileCerCSD: null,
  selectedFileKeyCSD: null,
  inputPasswordCSD: '',
  selectedFileCerFiel: null,
  selectedFileKeyFiel: null,
  inputPasswordFiel: '',
  openSuccessModal: false,
  openErrorModal: false,
  errorFilesCode: '',
  requestCSD: false,
  requestFiel: false,
  successFielDocuments: false,
  successCsdDocuments: false,
}


const initialFunctions: ContextFunctions = {
  setInputLogin: (x: string): void => {},
  setInputType: (x: string): void => {},
  Login: (): void => {},
  OtpValidation: (): void => {},
  setShowOtp: (x: boolean): void => {},
  setErrorMessages: (x: string): void => {},
  setUserToken: (x: string): void => {},
  setOtp: (x: string): void => {},
  setUserProfile: (x: any): void => {},
  setMaskedPhone: (x: string): void => {},
  setErrorMessagesOtp: (x: string): void => {},
  onFileChange: (): void => {},
  setSelectedFileCerCSD: (x: any): void => {},
  setSelectedFileKeyCSD: (x: any): void => {},
  uploadSellosFiles: (): void => {},
  uploadFielFiles: (): void => {},
  setInputPasswordCSD: (x: string): void => {},
  setSelectedFileCerFiel: (x: any): void => {},
  setSelectedFileKeyFiel: (x: any): void => {},
  setInputPasswordFiel: (x: string): void => {},
  setOpenSuccessModal: (x: boolean): void => {},
  setOpenErrorModal: (x: boolean): void => {},
  setErrorFilesCode: (x: string): void => {},
  setRequestCSD: (x: boolean): void => {},
  setRequestFiel: (x: boolean): void => {},
  setSuccessFielDocuments: (x: boolean): void => {},
  setSuccessCsdDocuments: (x: boolean): void => {},
}

export const perfilSatContext: React.Context<ContextState> =
  createContext<ContextState>({
    ...initialValues,
    ...initialFunctions
  });

interface Props {
  children: ReactNode;
}

export const PerfilSatProvider = ({ children }: Props): ReactElement => {
  const perfilSatFilter: ContextState = usePerfilSat();
  return (
    <perfilSatContext.Provider value={perfilSatFilter}>
      {children}
    </perfilSatContext.Provider>
  );
};